import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_PASSWORD = "updateUser";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_PASSWORD = "setPassword";
export const SET_ERROR = "setError";
export const SET_PROFILE = "setProfile";

const state = {
  errors: null,
  user: {
    name: "",
    api_call: 0,
    api_call_day: 0,
    package: {
      name: "",
      api_call: 1,
    },
  },
  isAuthenticated: !!JwtService.getToken(),
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  currentPackage(state) {
    return state.user.package;
  },
  currentPercentUsages(state) {
    return (
      (state.user.api_call_day / state.user.package.api_call) *
      100
    ).toFixed(2);
  },
  currentPercentUsagesm(state) {
    return (
      (state.user.api_call / (state.user.package.api_call * 30)) *
      100
    ).toFixed(2);
  },
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("v1/token/", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data.data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data.messages);
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [REGISTER](context, credentials) {
    return new Promise((resolve) => {
      ApiService.post("login", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.data.messages);
        });
    });
  },
  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.get("/v1/me/profile")
        .then(({ data }) => {
          context.commit(SET_PROFILE, data.data);
        })
        .catch(() => {
          context.commit(PURGE_AUTH);
        });
    } else {
      context.commit(PURGE_AUTH);
    }
  },
  [UPDATE_PASSWORD](context, payload) {
    const password = payload;

    return ApiService.put("password", password).then(({ data }) => {
      context.commit(SET_PASSWORD, data);
      return data;
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    JwtService.saveToken(user.access);
  },
  [SET_PASSWORD](state, password) {
    state.user.password = password;
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {
      name: "",
      package: {
        name: "",
      },
    };
    state.errors = {};
    JwtService.destroyToken();
  },
  [SET_PROFILE](state, user) {
    state.isAuthenticated = true;
    state.user = user;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
